document.addEventListener('DOMContentLoaded', function () {
  /* ===============================
     1. SMART STICKY & TRANSPARENT LOGIC
  =============================== */
  const spacer = document.getElementById('gb-header-spacer');
  const sectionWrapper = document.querySelector('.header-section-wrapper');
  const stickyEnabled = sectionWrapper ? sectionWrapper.getAttribute('data-sticky-enabled') === 'true' : false;
  const allHeaders = document.querySelectorAll('.header__wrapper');
  let lastScrollTop = 0;

  function getVisibleHeader() {
    const desktopHeader = document.querySelector('.header__desktop');
    const mobileHeader = document.querySelector('.header__mobile');
    if (desktopHeader && getComputedStyle(desktopHeader).display !== 'none') return desktopHeader;
    return mobileHeader;
  }

  function getPrecedingHeight() {
    if (!sectionWrapper) return 0;
    const parentSection = sectionWrapper.closest('.shopify-section') || sectionWrapper.parentElement;
    if (!parentSection) return 0;
    let totalHeight = 0;
    let sibling = parentSection.previousElementSibling;
    while (sibling) {
      const style = getComputedStyle(sibling);
      if (style.display !== 'none' && style.position !== 'fixed' && style.position !== 'absolute') {
        totalHeight += sibling.offsetHeight;
      }
      sibling = sibling.previousElementSibling;
    }
    return totalHeight;
  }

  function updateSpacerHeight() {
    const activeHeader = getVisibleHeader();
    const isTransparent = document.querySelector('.header__wrapper.is-transparent');
    if (stickyEnabled && spacer && activeHeader && !isTransparent) {
      spacer.style.height = activeHeader.offsetHeight + 'px';
    } else if (spacer) {
      spacer.style.height = '0px';
    }
  }

  if (stickyEnabled) {
    allHeaders.forEach(h => h.classList.add('gb-sticky-active'));
    setTimeout(() => { updateSpacerHeight(); }, 100);
    window.addEventListener('resize', () => { updateSpacerHeight(); });
  }

  window.addEventListener('scroll', function() {
    let scrollTop = window.scrollY || document.documentElement.scrollTop;
    const precedingHeight = getPrecedingHeight();
    
    if (scrollTop > precedingHeight + 5) { 
      allHeaders.forEach(h => h.classList.add('is-scrolled')); 
    } else { 
      allHeaders.forEach(h => h.classList.remove('is-scrolled')); 
    }
    
    if (stickyEnabled) {
      const activeHeader = getVisibleHeader();
      if (!activeHeader) return;
      const triggerPoint = precedingHeight + activeHeader.offsetHeight + 50;
      
      if (scrollTop > lastScrollTop && scrollTop > triggerPoint) {
        allHeaders.forEach(h => h.classList.add('gb-header-hidden'));
      } else if (scrollTop < lastScrollTop) {
        allHeaders.forEach(h => h.classList.remove('gb-header-hidden'));
      }
      lastScrollTop = scrollTop;
    }
  }, { passive: true });
  window.dispatchEvent(new Event('scroll'));

  /* ===============================
     2. MENU / DRAWER LOGIC
  =============================== */
  const openMenuBtn = document.getElementById('btn-open-menu');
  const closeMenuBtn = document.getElementById('btn-close-menu');
  const menuDrawer = document.getElementById('custom-mobile-drawer');
  const menuOverlay = document.getElementById('overlay-close-menu');
  const toggles = document.querySelectorAll('.js-mobile-toggle');

  if(openMenuBtn) openMenuBtn.addEventListener('click', () => menuDrawer.classList.add('is-open'));
  function closeMobileMenu() {
    if(closeMenuBtn) closeMenuBtn.classList.add('is-spinning');
    menuDrawer.classList.remove('is-open');
    setTimeout(() => {
      if(closeMenuBtn) closeMenuBtn.classList.remove('is-spinning');
      document.querySelectorAll('.js-mobile-toggle.active').forEach(t => t.classList.remove('active'));
      document.querySelectorAll('.mobile-submenu, .mobile-grandmenu').forEach(ul => ul.style.maxHeight = null);
    }, 400); 
  }
  if(closeMenuBtn) closeMenuBtn.addEventListener('click', closeMobileMenu);
  if(menuOverlay) menuOverlay.addEventListener('click', closeMobileMenu);
  
  const drawerSearchToggle = document.getElementById('btn-drawer-search-toggle');
  const drawerSearchBar = document.getElementById('drawer-search-bar');
  const drawerSearchInputObj = document.getElementById('js-drawer-search-input');
  
  if(drawerSearchToggle && drawerSearchBar){
    drawerSearchToggle.addEventListener('click', function(e){
        e.preventDefault();
        drawerSearchBar.classList.toggle('active');
        if(drawerSearchBar.classList.contains('active') && drawerSearchInputObj) {
            setTimeout(() => drawerSearchInputObj.focus(), 100);
        }
    });
  }

  function adjustParentHeights(element, change) {
    let parentUl = element.parentElement.closest('ul.mobile-submenu, ul.mobile-grandmenu');
    while (parentUl) {
      if (parentUl.style.maxHeight) {
        const currentHeight = parseFloat(parentUl.style.maxHeight) || 0;
        const newHeight = currentHeight + change;
        parentUl.style.maxHeight = (newHeight > 0 ? newHeight : 0) + 'px';
      }
      parentUl = parentUl.parentElement.closest('ul.mobile-submenu, ul.mobile-grandmenu');
    }
  }

  toggles.forEach(toggle => {
    toggle.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const submenu = this.nextElementSibling; 
      if (!submenu) return;
      const parentLi = this.parentElement;
      const parentUl = parentLi.parentElement;
      const isOpening = !this.classList.contains('active');

      if (parentUl) {
        const activeSiblingToggles = parentUl.querySelectorAll(':scope > li > .js-mobile-toggle.active');
        activeSiblingToggles.forEach(siblingToggle => {
          if (siblingToggle !== this) {
            const siblingSubmenu = siblingToggle.nextElementSibling;
            if(siblingSubmenu){
              const siblingHeight = siblingSubmenu.scrollHeight;
              siblingToggle.classList.remove('active');
              siblingSubmenu.style.maxHeight = null;
              adjustParentHeights(siblingSubmenu, -siblingHeight);
            }
          }
        });
      }

      this.classList.toggle('active');
      const height = submenu.scrollHeight;

      if (isOpening) {
        submenu.style.maxHeight = height + "px";
        adjustParentHeights(submenu, height);
        setTimeout(() => { this.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 300);
      } else {
        submenu.style.maxHeight = null;
        adjustParentHeights(submenu, -height);
      }
    });
  });

  /* ===============================
     3. CART LOGIC (USD AWARE)
  =============================== */
  const cartDrawer = document.getElementById('custom-cart-drawer');
  const cartOverlay = document.getElementById('overlay-close-cart');
  const closeCartBtn = document.getElementById('btn-close-cart');
  
  function openCart() { cartDrawer.classList.add('is-open'); fetchCart(); }
  function closeCart() { 
    if(closeCartBtn) closeCartBtn.classList.add('is-spinning');
    cartDrawer.classList.remove('is-open'); 
    setTimeout(() => { if(closeCartBtn) closeCartBtn.classList.remove('is-spinning'); }, 400);
  }

  document.querySelectorAll('.js-toggle-cart').forEach(btn => btn.addEventListener('click', (e) => { e.preventDefault(); openCart(); }));
  if(closeCartBtn) closeCartBtn.addEventListener('click', closeCart);
  if(cartOverlay) cartOverlay.addEventListener('click', closeCart);

  const cartBody = document.getElementById('js-cart-body');
  const cartFooter = document.getElementById('js-cart-footer');
  const cartSubtotal = document.getElementById('js-cart-subtotal');
  const cartBadges = document.querySelectorAll('.js-cart-count');

  function fetchCart() { fetch(window.Shopify.routes.root + 'cart.js').then(r => r.json()).then(updateCartUI); }

  function updateCartUI(cart) {
    cartBadges.forEach(b => {
      b.textContent = cart.item_count;
      b.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });

    if(cart.item_count === 0) {
      cartBody.innerHTML = '<p style="text-align:center;margin-top:50px;">Your cart is empty.</p>';
      cartFooter.style.display = 'none';
      return;
    }
    
    cartFooter.style.display = 'block';
    cartSubtotal.textContent = formatMoneyCents(cart.total_price);
    
    cartBody.innerHTML = cart.items.map(item => `
      <div class="cart-item">
        <img src="${item.image}" class="cart-item-img">
        <div class="cart-item-info">
          <a href="${item.url}" class="cart-item-title">${item.title}</a>
          <div class="cart-item-meta">Qty: ${item.quantity}</div>
          <div class="cart-item-price">${formatMoneyCents(item.price)}</div>
          <div class="cart-item-remove" onclick="removeItem('${item.key}')">Remove</div>
        </div>
      </div>
    `).join('');
  }

  window.removeItem = function (key) {
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: { [key]: 0 } })
    }).then(r => r.json()).then(updateCartUI);
  };

  // Safe global price formatting
  function formatMoneyCents(cents) {
    const amount = cents / 100;
    if (window.AwakenPricing && window.AwakenPricing.country !== 'IN') {
      const converted = amount / window.AwakenPricing.rate;
      return window.AwakenPricing.symbol + Math.round(converted).toLocaleString('en-US');
    }
    return '₹' + Math.round(amount).toLocaleString('en-IN');
  }

  document.addEventListener('theme:cart:change', function (event) {
    if (event.detail && event.detail.cart) {
      updateCartUI(event.detail.cart);
      if(sessionStorage.getItem('gbAutoOpenCart') === 'true' && !window.location.pathname.includes('/cart')) {
        openCart(); sessionStorage.removeItem('gbAutoOpenCart');
      }
    }
  });

  /* ===============================
     4. LIVE SMART SEARCH (USD AWARE)
  =============================== */
 function formatSearchPrice(priceStr) {
  if (!priceStr) return '';

  /*
    GLOBAL SEARCH PRICE RULE

    INDIA:
      Below ₹2,50,000 -> Show price
      ₹2,50,000+      -> Price on Request

    OUTSIDE INDIA:
      Always          -> Price on Request
  */

  const country =
    window.AwakenPricing &&
    window.AwakenPricing.country
      ? String(window.AwakenPricing.country).toUpperCase()
      : 'IN';

  /* -----------------------------------------
     OUTSIDE INDIA
     ALWAYS PRICE ON REQUEST
  ----------------------------------------- */
  if (country !== 'IN') {
    return `
      <span
        class="aw-search-price-request"
      >
        Price on Request
      </span>
    `;
  }

  /* -----------------------------------------
     INDIA
     BELOW ₹2,50,000 = NORMAL PRICE
     ₹2,50,000+      = PRICE ON REQUEST
  ----------------------------------------- */

  const numericString = String(priceStr).replace(/[^0-9.]/g, '');
  const amount = parseFloat(numericString);

  if (isNaN(amount)) {
    return priceStr;
  }

  if (amount >= 250000) {
    return `
      <span
        class="aw-search-price-request"
      >
        Price on Request
      </span>
    `;
  }

  return '₹' + Math.round(amount).toLocaleString('en-IN');
}

  function setupLiveSearch(inputEl, resultsEl, clearEl) {
    if (!inputEl || !resultsEl) return;
    let debounceTimer;

    if (clearEl) {
      inputEl.addEventListener('input', function() {
          if(this.value.length > 0) clearEl.style.display = 'block'; else clearEl.style.display = 'none';
      });
      clearEl.addEventListener('click', function() {
          inputEl.value = ''; clearEl.style.display = 'none'; inputEl.focus();
          resultsEl.innerHTML = ''; resultsEl.classList.remove('has-results');
      });
    }

    inputEl.addEventListener('input', (e) => {
      clearTimeout(debounceTimer);
      const query = e.target.value.trim();
      if (query.length === 0) { resultsEl.innerHTML = ''; resultsEl.classList.remove('has-results'); return; }

      debounceTimer = setTimeout(() => {
        fetch(`${window.Shopify.routes.root}search/suggest.json?q=${query}&resources[type]=product&resources[limit]=5`)
          .then(res => res.json())
          .then(data => {
            const products = data.resources.results.products;
            if (products && products.length > 0) {
              resultsEl.innerHTML = products.map(p => `
                <a href="${p.url}" class="gb-result-item">
                  <img src="${p.image}" class="gb-result-img" alt="${p.title}">
                  <div class="gb-result-title">${p.title}<br><small style="color: #1a2f31; font-weight: 600;">${formatSearchPrice(p.price)}</small></div>
                </a>
              `).join('');
              resultsEl.classList.add('has-results');
            } else {
              resultsEl.innerHTML = '<div style="padding:15px;text-align:center;color:#666;">No results found.</div>';
              resultsEl.classList.add('has-results');
            }
          });
      }, 300);
    });
  }

  setupLiveSearch(document.getElementById('js-desktop-search-input'), document.getElementById('js-desktop-live-results'), document.getElementById('js-desktop-clear'));
  setupLiveSearch(document.getElementById('js-mobile-search-input'), document.getElementById('js-mobile-live-results'), null);
  setupLiveSearch(document.getElementById('js-drawer-search-input'), document.getElementById('js-drawer-live-results'), null);

  /* ===============================
     5. TOGGLE LOGIC FOR SEARCH BARS
  =============================== */
  const desktopSearchTrigger = document.getElementById('js-search-trigger');
  const desktopSearchBar = document.getElementById('js-search-bar');
  const desktopSearchCloseBtn = document.getElementById('js-bar-close');
  
  if (desktopSearchTrigger && desktopSearchBar) {
    desktopSearchTrigger.addEventListener('click', () => {
      desktopSearchBar.classList.add('active');
      const input = document.getElementById('js-desktop-search-input');
      if (input) setTimeout(() => input.focus(), 100);
    });
  }

  if (desktopSearchCloseBtn && desktopSearchBar) {
    desktopSearchCloseBtn.addEventListener('click', () => {
      desktopSearchBar.classList.remove('active');
      const results = document.getElementById('js-desktop-live-results');
      const input = document.getElementById('js-desktop-search-input');
      const clear = document.getElementById('js-desktop-clear');
      if (results) { results.innerHTML = ''; results.classList.remove('has-results'); }
      if (input) { input.value = ''; if(clear) clear.style.display = 'none'; }
    });
  }

  const mobileSearchTrigger = document.getElementById('js-mobile-search-trigger');
  const mobileSearchBar = document.getElementById('js-mobile-search-bar');

  if (mobileSearchTrigger && mobileSearchBar) {
    mobileSearchTrigger.addEventListener('click', function(e) {
      e.preventDefault();
      mobileSearchBar.classList.toggle('active');
      const input = document.getElementById('js-mobile-search-input');
      if(input && mobileSearchBar.classList.contains('active')) setTimeout(() => input.focus(), 100);
    });
  }

  /* ===============================
     6. DYNAMIC TYPEWRITER SEARCH
  =============================== */
  const desktopSearchInput = document.getElementById('js-desktop-search-input');
  const mobileSearchInput = document.getElementById('js-mobile-search-input');
  const drawerSearchInput = document.getElementById('js-drawer-search-input');
  
  const allSearchInputs = [desktopSearchInput, mobileSearchInput, drawerSearchInput];
  
  const searchTerms = ["engagement diamond ring", "pear shaped diamond ring", "diamond hoop earrings", "tennis necklace", "diamond line bracelet"];
  
  let wordIndex = 0;
  let charIndex = 0;
  let isDeleting = false;
  
  function typeEffect() {
    const currentWord = searchTerms[wordIndex];
    const currentText = currentWord.substring(0, charIndex);
    
    allSearchInputs.forEach(input => {
      if(input) {
        input.setAttribute('placeholder', 'Search for ' + currentText + (isDeleting ? '' : '...'));
      }
    });
    
    let typingSpeed = isDeleting ? 50 : 100;
    
    if (!isDeleting && charIndex < currentWord.length) {
      charIndex++;
      setTimeout(typeEffect, typingSpeed);
    } else if (isDeleting && charIndex > 0) {
      charIndex--;
      setTimeout(typeEffect, typingSpeed);
    } else {
      isDeleting = !isDeleting;
      if (!isDeleting) {
        wordIndex = (wordIndex + 1) % searchTerms.length;
        setTimeout(typeEffect, typingSpeed);
      } else {
        setTimeout(typeEffect, 2000); 
      }
    }
  }
  
  setTimeout(typeEffect, 1000);
});